import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import {ModelService} from '@service/model/model.service';
import {ActivatedRoute, Router, RouterStateSnapshot} from '@angular/router';
import {isSinglePlacement, Placement} from '@interface/model/placement/placement';
import {ConfigurationView} from '@enum/model/configuration/configuration.view';
import {
  MutuallyExclusive,
  MutuallyExclusiveGrouped,
  WidgetConfiguration
} from '@interface/model/widget/widget.configuration';
import {WidgetCode} from '@enum/widget/widgetCode';
import {HeaderService} from '@service/header/header.service';
import {HeaderStep} from '@enum/header.step';
import {CommonService} from '@service/common/common.service';
import {MatTab, MatTabChangeEvent, MatTabGroup} from '@angular/material/tabs';
import {ModelConfiguration} from '@interface/model-configuration/model-configuration';
import {
  configurationHasEto,
  ModelPrebuiltConfiguration
} from '@interface/model-prebuilt-configurations/model-prebuilt-configuration';
import {OrderService} from '@service/order/order.service';
import {PlacementType} from '@enum/placement-type/placement-type';
import {
  ConfigurationTab,
  ConfigurationTabType,
  stringToConfigurationTabType
} from '@enum/configuration-tab/configuration-tab';
import {PlacementInfo} from '@enum/placement-info/placement-info';
import {MatDialog} from '@angular/material/dialog';
import {VestaService} from '@service/vesta/vesta.service';
import {ConfigurationService} from '@service/configuration/configuration.service';
import {ConfigurationUpdate} from '@enum/common/configuration-update';
import {BoxedType} from '@enum/common/boxed-type';
import {AuthService} from '@service/auth/auth.service';
import {AddToOrderComponent} from '../../components/add-to-order/add-to-order.component';
import {forkJoin, from, merge, Observable, of, Subject, Subscription, timer} from 'rxjs';
import {ModelConfigurationsComponent} from '../../components/model/model-configurations/model-configurations.component';
import {DexiedbService, HistoryMessage} from '@service/dexiedb/dexiedb.service';
import {ProformaSection} from '@enum/proformaSection';
import {RequestEstimateComponent} from '../../components/request-estimate/request-estimate.component';
import {ConfigurabilityStructure} from '@interface/model/configurability/configurability.structure';
import {ConfigurabilityCommercialLines} from '@interface/model/configurability/configurability.commercial.lines';
import {VirginStructureConfigurata} from '@interface/configuration/virgin.structure';
import {BoxedStructure, isBoxedStructure, OptionalsStructure} from '@interface/configuration/optionals.structure';
import {
  ConfigurationMaterialColor,
  MutuallyExclusivePlacementList,
  PlacementConfiguration,
  PlacementConfigurationSummary,
  StrutturaElemento,
  StrutturaOpzionale
} from '@interface/configuration/placement.configuration';
import {PlacementOptional} from '@interface/model/placement/placement.optional';
import {ConfigurabilityGroup} from '@interface/model/configurability/configurability.group';
import {OptionalType} from '@enum/common/optional-type';
import {ConfigurabilityUngrouped} from '@interface/model/configurability/configurability.ungrouped';
import {ConfigurationState} from '@enum/configuration-state/configuration-state';
import {RepairImageUrlPipe} from '@app/pipes/sort/repair-image-url.pipe';
import {RuleInfo} from '@interface/model/configurability/cross.restriction.rule';
import {CrossRestrictionUtils} from '../../shared/utils/cross.restriction.utils';
import {filter, first, map, switchMap, take, takeUntil, tap} from 'rxjs/operators';
import {isGroupPlacement} from '@interface/model/configurability/configurability.group.element';
import {isMutableOrderState} from '@enum/common/order-state';
import {ProformaCartLabels} from '@interface/proforma-cart-labels';
import {TrackEventsService} from '@service/track-events/track-events.service';
import {ModalService} from '@service/modal/modal.service';
import {NavigationService} from '@service/navigation/navigation.service';
import {MatAccordion} from '@angular/material/expansion';
import {SwiperImage} from "../../components/swiper/swiper.component";

interface BodyInterface {
  placementId?: number;
  idGroup?: number;
  placementType: PlacementType;
  ruleList?: RuleInfo[];
}


@Component({
    selector: 'app-model-configuration',
    templateUrl: './model-configuration.component.html',
    styleUrls: ['./model-configuration.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ModelConfigurationComponent implements OnInit, AfterViewChecked, OnDestroy {

  @ViewChild('vestaContainer') vestaContainer: ElementRef | undefined;
  @ViewChild('tabGroup') tabGroup: MatTabGroup | undefined;
  @ViewChild('backToConf') backToConf: TemplateRef<any> | undefined;
  @ViewChild('resetConf') resetConf: TemplateRef<any> | undefined;
  @ViewChild('saveConfModal') saveConfModal: TemplateRef<any> | undefined;
  @ViewChild('endColumn') endColumn: ElementRef | undefined;
  @ViewChild('askToDeactivateLines') askToDeactivateModel: TemplateRef<any> | undefined;
  @ViewChild('askToRestore') askToRestore: TemplateRef<any> | undefined;
  @ViewChild('colRight') colRight: ElementRef | undefined;
  @ViewChildren(ModelConfigurationsComponent) configurationsComponent: QueryList<ModelConfigurationsComponent> | undefined;
  @ViewChild('listsAccordion', { read: MatAccordion })
  listsAccordion?: MatAccordion;
  private destroy$ = new Subject();
  private afterViewChecked$ = new Subject();
  public view: ConfigurationView = ConfigurationView.CONFIGURATION_SUMMARY;
  public selectedWidgetConfiguration: WidgetConfiguration | null = null;
  public currentPlacementConfiguration: {
    mutuallyExclusiveOptions?: {
      configurabilityPlacement: ConfigurabilityCommercialLines | ConfigurabilityGroup | PlacementOptional,
      configurabilityBody: BodyInterface,
      ungrouped?: MutuallyExclusive[],
      grouped?: MutuallyExclusiveGrouped[]
    };
    configurationList?: WidgetConfiguration[];
  } = {};
  public modelConfiguration?: ModelConfiguration;
  public selectedWidget: WidgetCode | null = null;
  public configurationView = ConfigurationView;
  public workingPlacement: (ConfigurabilityCommercialLines | ConfigurabilityGroup | PlacementOptional) & { opzionale?: boolean; currentName?: string } | null = null;
  public summaryData: {
    imagePath: string,
    productName: string,
    configurationName: string,
    configurationSaleCode: string,
    configurationDescriptionList: string[],
    modelName: string,
    productSizes: string,
    productSizes2: string,
    optionPrice: number,
    priceUnit: number,
    configurationId: number,
    configurationState: ConfigurationState,
    basePrice: string,
    totalPrice: string,
    totalPriceTaxed: string,
    eto: boolean
  } | null = null;
  public widgetCode = WidgetCode;
  public currentTabIndex = 0;
  public product: {
    configurability?: ConfigurabilityStructure,
    detail?: {
      modelCode: string,
      modelId: number,
      productId: number,
      bomId: number,
      productName: string,
      productNameForTrack: string,
      productCode: string,
      categoryId: number,
      categoryName: string,
      categoryNameForTrack: string,
      shortDescription: string,
      vestaId: string,
      vestaCode: string,
      vestaExternalLink: string,
      productState: ConfigurationState,
      newPrebuiltEnabled: boolean,
      imagePath: string | false,
      images: { list?: string[], indexPos?: number, converted: SwiperImage[]},
      ext_links: string[],
      no3D: boolean,
      underConstruction: boolean,
      productAcademyUrl: string,
      modelAcademyUrl: string,
      colorNumber: string,
      materialNumber: string,
      factorizedName: {
        subCategory: any[],
        dimensions: string
      }
    },
    configurazioniPrebuilt?: ModelPrebuiltConfiguration[],
    configurazioniSalvate?: ModelPrebuiltConfiguration[],
    configurazioniCliente?: ModelPrebuiltConfiguration[],
    configurazioniOrdine?: ModelPrebuiltConfiguration[],
    optionalConfigurability?: OptionalsStructure,
    images?: ({ imagePath?: string } | string)[]
  } = {};
  public subCategoryString: string | undefined;
  public optionalsBoxedUnboxed: ({
    type: BoxedType.BOXED,
    index: number,
    optional: BoxedStructure
  } | {
    type: BoxedType.UNBOXED,
    index: number,
    optional: PlacementOptional
  })[] = [];
  BoxedType = BoxedType;
  public default = false;
  public globalConfigurationId: number | null = null;
  public productId: string | undefined;
  private _loaded = false;
  public notFound = false;
  public configurationName: string | null = null;
  public saved = false;
  public showPlacementsConfigurability = false;
  public configurationId: number | null = null;
  public vestaReady = true;
  public bomId: number | undefined;
  public enableVesta: boolean | null = null;
  public b2cAddToOrderEnabled = false;
  public disclaimerTime = false;
  public disclaimerTimeValue = false;
  public hideButton = true;
  public etoFlow = false;
  public etoId: any;
  public currentSelectedPlacement: any;
  private configurationUpdate$ = new Subscription();
  // Viene impostata quando si entra in modifica in questa pagina
  public singleConfigurationId: number | null = null;
  private readonly repairUrl = new RepairImageUrlPipe();
  public currentRule?: {
    mastersConfiguration: RuleInfo[],
    placementsWithSameConfiguration: ConfigurabilityCommercialLines[]
  };
  private lastConfiguredPlacements: { placementId?: number; idGroup?: number }[] = [];
  public placementsToAskDeactivate: ConfigurabilityCommercialLines[] = [];
  public noConfigurationLines = false;
  private showSaveEditing = false;
  private currentOrderId: number | null = null;
  public editingSaved = false;
  public lastModifiedConfigurationId?: number;
  private recoveringConfiguration = false;
  public isDrawerConfigurationClosed = false;
  private screenshot: { url: null | string; base64: null | string; } = {url: null, base64: null};
  public warningTimeoutObj = {
    TIMEOUT: Symbol('timeout'),
    show: true,
    isTimeout: false,
    isEmpty: true,
    reset(): void {
      this.show = true;
      this.isTimeout = false;
      this.isEmpty = true;
    },
    canShow(): boolean {
      return this.show && this.isTimeout && !this.isEmpty;
    }
  };
  private readonly timeoutVestaGrouping = 5000;
  isPrinting: boolean;

  constructor(private modelService: ModelService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private common: CommonService,
              public orderService: OrderService,
              private headerService: HeaderService,
              private dialog: MatDialog,
              private ngZone: NgZone,
              private cd: ChangeDetectorRef,
              private vestaService: VestaService,
              private configuration: ConfigurationService,
              private authService: AuthService,
              private modalService: ModalService,
              private navigation: NavigationService,
              private db: DexiedbService,
              private trackEventsService: TrackEventsService) {
    this.modelConfigurationReset();
    this.common.vestaOutputData
      .pipe(takeUntil(this.destroy$)).subscribe(
      (data => {
        if (data?.detail) {
          const externalId = data?.detail;
          if (externalId) {
            if (this.modelConfiguration?.tabSelezionato === ConfigurationTab.UNGROUPED || !this.modelConfiguration?.tabSelezionato) {
              this.handleVestaClickUngroupedTab(externalId);
            } else {
              this.handleVestaClickGrouped(externalId);
            }
            this.isDrawerConfigurationClosed = false;
          } else {
            this.visualizzaSchermataDiConfigurazione();
          }
        } else {
          this.visualizzaSchermataDiConfigurazione();
        }
      }));
    this.configuration.historyObservable.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.updateTab();
      this.updateOptionalConfigurability();
      if (data?.message !== HistoryMessage.Recover) {
        this.checkIfAutoEnableVesta();
      }
      if (data?.message === HistoryMessage.OpenConfiguration) {
        this.isHistoryEmpty().then(emptyHistory => {
          if (!emptyHistory) {
            this.editCurrentConfiguration(true);
          }
        });
      }
    });
    this.isPrinting = false;
  }

  private static extractBodyForPlacementAndGroups(group: boolean | undefined, placement: ConfigurabilityCommercialLines | ConfigurabilityGroup): BodyInterface {
    if (!group && 'placementId' in placement) {
      return {placementId: placement.placementId || undefined, placementType: placement.placementType};
    } else {
      return {idGroup: placement.idGroup || undefined, placementType: placement.placementType};
    }
  }

  set loaded(value: boolean) {
    this._loaded = value;
    this.cd.markForCheck();
  }

  get loaded(): boolean {
    return this._loaded;
  }

  ngAfterViewChecked(): void {
    this.afterViewChecked$.next(undefined);
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  public get proformaLabels(): ProformaCartLabels {
    return this.authService.currentUserPermission.proformaCartLabels;
  }

  public get isDefaultUntaxedPrice(): boolean {
    return this.authService.currentUserPermission.isDefaultUntaxedPrice;
  }

  public canExit(nextState: RouterStateSnapshot): Observable<boolean> {
    // not used anymore
    if (nextState.url === '/login' && !this.checkAuth()) {
      return of(true);
    } else {
      const result = new Subject<boolean>();
      this.isHistoryEmpty().then(emptyHistory => {
        if (emptyHistory) {
          result.next(true);
          result.complete();
        } else if (this.backToConf) {
          const yesNoDialog = this.dialog.open(this.backToConf);
          yesNoDialog.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(res => {
            if (res) {
              this.db.resetHistory(Number(this.productId)).then();
            }
            result.next(res);
            result.complete();
          });
        } else {
          result.next(true);
          result.complete();
        }
      });
      return result.asObservable();
    }
  }

  public vestaAction(activate: boolean): void {
    this.enableVesta = activate;
    if (activate) {
      this.configuration.inizializzaStrutturaVesta();
      this.configuration.inizializzaStrutturaVesta(this.estraiStrutturaTabSelezionato());
      this.configuration.aggiornaVesta();
      setTimeout(() => {
        this.hideButton = false;
        this.cd.markForCheck();
      }, this.timeoutVestaGrouping);
    }
    this.cd.markForCheck();
  }

  public forceGrouping(): void {
    this.configuration.aggiornaVesta(this.estraiStrutturaTabSelezionato());
  }

  public getSelectedIndex(): number {
    return this.currentTabIndex;
  }

  public selezionaTab(tabChangeEvent: MatTabChangeEvent): void {
    this.currentTabIndex = tabChangeEvent.index;
    this.configuration.currentTabIndex = tabChangeEvent.index;
    if (tabChangeEvent?.tab?.ariaLabel) {
      const groupLabel = tabChangeEvent.tab.ariaLabel;
      this.aggiornaTabSelezionato(groupLabel);
      this.updateOptionalConfigurability();
    }
  }

  public updateTab(): void {
    if (this.currentTabIndex !== this.configuration.currentTabIndex) {
      this.currentTabIndex = this.configuration.currentTabIndex;
      this.aggiornaTabSelezionato('GROUP_ID-' + String(this.configuration.tabSelezionato));
    }
  }

  private getInfoFromConfigurationId(configurationId: number): void {
    this.showSaveEditing = true;
    this.singleConfigurationId = configurationId;
    this.currentOrderId = this.orderService.currentOrder?.id || null;
    this.etoFlow = false;
    this.etoId = null;
  }

  private getInfoFromParams(params: { id?: string; actionOrConfigurationId?: string, otherId?: string }): void {
    if (params.id) {
      this.productId = params.id;
      if (params.actionOrConfigurationId) {
        switch (params.actionOrConfigurationId) {
          case ProformaSection.ETO:
            this.etoFlow = !!params.otherId;
            this.etoId = params.otherId;
            break;
          case 'recover':
            this.getInfoFromConfigurationId(Number(params.otherId));
            this.recoveringConfiguration = true;
            break;
          default:
            this.getInfoFromConfigurationId(Number(params.actionOrConfigurationId));
            break;
        }
      }
      const body = {productId: Number(params.id)};
      this.getProductInfo(body, true);
      this.cd.markForCheck();
    }
  }

  ngOnInit(): void {
    this.update();
    this.headerService.header.next(HeaderStep.CONFIGURATION);
    this.activatedRoute.params
      .pipe(takeUntil(this.destroy$))
      .subscribe((params: { id?: string; actionOrConfigurationId?: string, otherId?: string }) => {
        this.getInfoFromParams(params);
      });
    this.authService.checkB2cAddToOrderEnabled()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data?.error) {
          this.b2cAddToOrderEnabled = false;
        } else {
          this.b2cAddToOrderEnabled = (data?.enabled === true || data?.enabled === 'True' || data?.enabled === 'true' || data?.enabled === '1');
        }
        this.cd.markForCheck();
      });
    this.orderService.summaryDisclaimer()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data?.error) {
          this.disclaimerTime = false;
        } else {
          this.disclaimerTime = data?.disclaimer;
          this.disclaimerTimeValue = data?.disclaimerValue;
        }
        this.cd.markForCheck();
      });
  }

  private checkIfAutoEnableVesta(): void {
    if (this.enableVesta !== null) {
      return;
    }
    this.enableVesta = false;
    const timeoutObservable = <T>(obs: Observable<T>, timeout: number) =>
      merge(obs, timer(timeout).pipe(map(() => this.warningTimeoutObj.TIMEOUT))).pipe(
        filter((_, i) => i < 1)
      );

    this.warningTimeoutObj.reset();
    forkJoin([
      timeoutObservable(
        from(this.isHistoryEmpty()).pipe(
          tap((empty) => {
            this.warningTimeoutObj.isEmpty = empty;
            if (this.warningTimeoutObj.canShow()) {
              this.editCurrentConfiguration(true);
            }
            this.cd.markForCheck();
          })
        ),
        this.db.timeoutHistory
      ).pipe(
        tap((emptyOrTimeout) => {
          this.warningTimeoutObj.isTimeout = (emptyOrTimeout === this.warningTimeoutObj.TIMEOUT || !!this.singleConfigurationId);
          this.cd.markForCheck();
        }),
        switchMap((emptyOrTimeout) => this.askToRestoreModal(emptyOrTimeout))
      ),
      this.common.configurationUpdate.pipe(
        filter(d => d),
        take(1),
        switchMap(() => this.vestaService.vestaEnableConf())
      )
    ]).pipe(takeUntil(this.destroy$)).subscribe(([_, data]) => {
        this.enableVesta = !data?.error && (data?.enabled === 'True' || data?.enabled === 'true' || data?.enabled === '1');
        if (this.enableVesta) {
          setTimeout(() => {
            this.forceGrouping();
          }, this.timeoutVestaGrouping);
        }
        this.cd.markForCheck();
    });
  }

  public editCurrentConfiguration(edit: boolean): void {
    if (edit) {
      // this.configurationsComponent?.forEach((conf: ModelConfigurationsComponent) => conf.collapseAll());
      this.listsAccordion?.closeAll();
      this.showPlacementsConfigurability = edit;
      this.visualizzaSchermataDiConfigurazione();
      this.cd.markForCheck();
    } else {
      const closeConfiguration = (close: boolean) => {
        if (close) {
          this.showPlacementsConfigurability = false;
          this.resetConfigurationChanges();
        } else {
          this.showPlacementsConfigurability = true;
        }
        this.cd.markForCheck();
      };
      this.isHistoryEmpty().then(emptyHistory => {
        if (emptyHistory) {
          closeConfiguration(true);
        } else if (this.resetConf) {
          this.dialog.open(this.resetConf).afterClosed().pipe(takeUntil(this.destroy$))
            .subscribe(res => closeConfiguration(res));
        } else {
          closeConfiguration(false);
        }
      });
    }
  }

  public changeModel(): void {
    this.router.navigate(['model-detail-grid', String(this.product.detail?.modelId), String(this.product.detail?.categoryId)]);
  }

  public askEstimate(): void {
    const dialogRef = this.dialog.open(RequestEstimateComponent, {
      width: '30vw',
      minWidth: '30rem',
      panelClass: ['modal-no-padding']
    });
    dialogRef.componentInstance.rawData = this.estraiDatiSummary(this.configurationId);
    dialogRef.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((requested) => {
        if (requested) {
          this.trackEventsService.requestEstimateConfigurator(this.getDataForTrackService());
        }
    });
  }

  public register(): void {
    this.navigation.goToRegister();
  }

  needActionForCreateNewUser(): string | false {
    return this.authService.shopVendorInfo?.needAction || false;
  }

  missingInfoForCustomer(): string | false {
    return this.authService.missingInfo ? 'COMPLETE_MISSING_INFO_SUMMARY' : false;
  }

  public preventFromGoToSummary(): boolean {
    let result: boolean;
    if (this.authService.currentUserPermission.canAlwaysGoToConfigurationSummary) {
      result = true;
    } else {
      result = this.checkIfAllElementsAreSelected() && !this.needActionForCreateNewUser() && !this.missingInfoForCustomer();
    }
    return !result;
  }

  public async getSummary(configurationId: number | null, validate = false): Promise<any> {
//    this.refreshConfigurationId();
    const strutturaFinale = this.estraiDatiSummary(configurationId);
    const data = await this.orderService.summary({
      ...strutturaFinale,
      validate
    }).toPromise();
    if (data?.error) {
      this.common.showErrorToast(data?.error);
    } else {
      this.subCategoryString = this.product?.detail?.factorizedName?.subCategory.toString();
      return data;
    }
  }

  public goToSummary(): void {
    if (!this.checkAuth()) {
      this.login();
    } else {
      this.loaded = false;
      this.getSummary(this.configurationId).then((data: any) => {
        this.loaded = true;
        this.summaryData = data;
        this.configurationId = data?.configurationId;
        this.view = ConfigurationView.CONFIGURATION_FINAL_SUMMARY;
        this.headerService.header.next(HeaderStep.SUMMARY);
        this.editingSaved = false;
        this.cd.markForCheck();
      });
    }
  }

  public modelBomId(event: { bomId: number, productId: number }): void {
    if (event.bomId) {
      this.bomId = event.bomId;
      this.initalizeModelConfiguration();
      this.configuration.estraiStrutturaOriginale(event.bomId, event.productId);
    }
  }

  /*
    public screenshot(): void {
      this.saveConfigurationImage();
    }
  */

  public createNewConfiguration(newPrebuilt: boolean): void {
    this.deselectAllConfigurations();
    this.initalizeModelConfiguration(newPrebuilt);
    this.vestaService.estraiStrutturaIniziale();
  }

  public applyConfiguration(configuration: ModelPrebuiltConfiguration): void {
    this.deselectAllConfigurations();
    configuration.selected = true;
    this.selezionaTabPerConfigurazione(configuration);
    this.configuration.applicaConfigurazione(configuration, this.currentTabIndex);
    if (this.modelConfiguration) {
      this.modelConfiguration.selectedConfigurationData = configuration;
    }
    this.cd.markForCheck();
  }

  private applyDefaultPrebuilt(): void {
    if (this.product.configurazioniPrebuilt) {
      const defaultPrebuilt = this.product.configurazioniPrebuilt.find((configurazione: ModelPrebuiltConfiguration) => configurazione.default);
      if (defaultPrebuilt) {
        this.applyConfiguration(defaultPrebuilt);
        this.globalConfigurationId = defaultPrebuilt.configurationId;
      }
    }
    this.checkIfAutoEnableVesta();
  }

  public editConfiguration(configuration: ModelPrebuiltConfiguration): void {
    if (configuration) {
      this.applyConfiguration(configuration);
      this.singleConfigurationId = configuration.configurationId;
      this.currentOrderId = -1;
      if (this.modelConfiguration) {
        this.modelConfiguration.editing = true;
      }
      if (this.product.configurazioniPrebuilt && this.product.configurazioniPrebuilt.length > 0) {
        this.setConfigurationEditing(configuration, this.product.configurazioniPrebuilt);
      }
      if (this.product.configurazioniSalvate && this.product.configurazioniSalvate.length > 0) {
        this.setConfigurationEditing(configuration, this.product.configurazioniSalvate);
      }
    }
  }

  public cancelEditingConfiguration(configuration?: ModelPrebuiltConfiguration): void {
    if (configuration) {
      this.applyConfiguration(configuration);
      this.configurationId = null;
      if (this.modelConfiguration) {
        this.modelConfiguration.editing = false;
      }
    }
  }

  public undoCreateNewPrebuilt(): void {
    this.applyDefaultPrebuilt();
    if (this.modelConfiguration) {
      this.modelConfiguration.newPrebuilt = false;
    }
  }

  public checkIfMutuallyExclusiveSelected(): boolean {
    let result = false;
    if (this.currentPlacementConfiguration?.mutuallyExclusiveOptions?.configurabilityPlacement &&
      'configurable' in this.currentPlacementConfiguration?.mutuallyExclusiveOptions?.configurabilityPlacement) {
      const notConfigurable = !this.currentPlacementConfiguration?.mutuallyExclusiveOptions?.configurabilityPlacement?.configurable;
      if (notConfigurable) {
        const selectedAtLeastOne = this.currentPlacementConfiguration?.mutuallyExclusiveOptions?.ungrouped?.find((placement: MutuallyExclusive) => {
          return placement.selected === true;
        });
        result = !!selectedAtLeastOne;
      }
    }
    return result;
  }

  public configuraPlacementOpzionale(placement: PlacementOptional): void {
    // todo in case of optional placement compacted need to be considered as group
    const body = ModelConfigurationComponent.extractBodyForPlacementAndGroups(false, placement);
    let group: ConfigurabilityGroup | undefined;
    if (placement.groupsInfo?.idGroup && placement.groupsInfo.idGroup === +(this.modelConfiguration?.tabSelezionato || 0)) {
      group = this.returnProductGroups().find(optGroup => optGroup.idGroup === placement.groupsInfo?.idGroup);
    }
    if (group) {
      this.clickSuPlacement(group, true, 'GROUP_ID-' + group.idGroup);
    } else {
      this.checkExclusive(body, placement, true);
    }
  }

  /*
    public handleOptionalToReplace(placement: Placement): void {
      if (placement) {
        this.configuration.strutturaModelloConfigurata.map((element: any) => {
          if (element.optionalElementInfo?.placementToReplace === placement.placementId && element.active) {
            // element.active = false;
            this.configuration.attivaSpegniPlacementOpzionale(element, false);
          }
        });
        // this.configuration.strutturaOpzionaleOriginale.boxed.map((element: any) => {
        //   if (element.placementToReplace === placement.placementId) {
        //     element.active = false;
        //   }
        // });
        // this.configuration.strutturaOpzionaleOriginale.unboxed.map((element: any) => {
        //   if (element.placementToReplace === placement.placementId) {
        //     element.active = false;
        //   }
        // });
      }
    }
  */

  public clickSuPlacement(placement: ConfigurabilityCommercialLines | ConfigurabilityGroup, group: boolean, groupLabel: string): void {
    // this.handleOptionalToReplace(placement);
    if (isSinglePlacement(placement) && this.checkActiveOptional(placement)) { // optionalReplaceList only for singlePlacement
      return;
    }
    this.aggiornaTabSelezionato(groupLabel);
    if (placement?.placementType === PlacementType.GROUP) {
      group = true;
    }
    const body = ModelConfigurationComponent.extractBodyForPlacementAndGroups(group, placement);
    this.checkExclusive(body, placement, false);
  }

  public visualizzaSchermataDiConfigurazione(): void {
    if (!this.workingPlacement) {
      this.goToSchermataDiConfigurazione();
    } else {
      const checkRuleIds = CrossRestrictionUtils.getRuleInfoToCheckForPlacement(this.workingPlacement, this.configuration.getAllElementsForSummary);
      this.checkIfForceSameConfiguration()
        .pipe(
          switchMap(() => {
            if (checkRuleIds) {
              return this.modelService.checkRestrictionRule(checkRuleIds);
            } else {
              return of(false as false);
            }
          }),
          takeUntil(this.destroy$)
        )
        .subscribe((data: { placementId?: number, idGroup?: number }[] | false) => {
          if (!data) {
            this.goToSchermataDiConfigurazione();
          } else {
            if (data.length === 0) {
              this.goToSchermataDiConfigurazione();
            } else {
              const distinct = (value: number, index: number, arr: number[]) => arr.indexOf(value) === index;
              const placementIds = data.map(plc => plc.placementId).filter(placementId => placementId) as number[];
              const idGroups = data.map(plc => plc.idGroup).filter(idGroup => idGroup) as number[];
              this.askToDeactivateLines(placementIds.filter(distinct), idGroups.filter(distinct));
            }
        }
      });
    }
  }

  private checkIfForceSameConfiguration(): Observable<null> {
    if (this.workingPlacement) {
      const confLines = this.configuration.getAllElementsForSummary;
      const masterConfiguration = confLines.find(conf => this.workingPlacement && CrossRestrictionUtils.isMatchPlacement(conf.configuration, this.workingPlacement));
      if (masterConfiguration && CrossRestrictionUtils.isPlacementConfigured(masterConfiguration)) {
        const plcSameConf = CrossRestrictionUtils.getPlacementsWithForceSameConfiguration(masterConfiguration, this.getAllPlacementsForCurrentTab());
        return this.configuration.setMaterialColorForPlacements(masterConfiguration, plcSameConf);
      }
    }
    return of(null);
  }

  private askToDeactivateLines(placementIds: number[], idGroups: number[]): void {
    const confLines = this.configuration.getAllElementsForSummary;

    const shouldBeRemoveConfiguration = (conf: ConfigurabilityCommercialLines) =>
      (conf.placementId && placementIds.includes(conf.placementId)) || (conf.idGroup && idGroups.includes(conf.idGroup));
    const findConfLine = (commLine: ConfigurabilityCommercialLines) =>
      confLines.find(conf => CrossRestrictionUtils.isMatchPlacement(commLine, conf.configuration));
    const isPlcActive = (conf?: PlacementConfigurationSummary) =>
      conf && conf.configuration.active !== false && conf.configuration.flagActive !== false;

    const linesToDeactivate = this.estraiStrutturaTabSelezionato()?.filter(shouldBeRemoveConfiguration) || [];
    const optionalLinesToDeactivate = this.product.optionalConfigurability ?
      this.product.optionalConfigurability[BoxedType.UNBOXED].filter(shouldBeRemoveConfiguration)
        .concat(this.product.optionalConfigurability[BoxedType.BOXED]
          .reduce((acc, boxed) => acc.concat(boxed.placementOptionalList), [] as PlacementOptional[])
          .filter(shouldBeRemoveConfiguration)) : [];
    const allPlacementsToDeactivate = linesToDeactivate.concat(optionalLinesToDeactivate);
    this.placementsToAskDeactivate = linesToDeactivate
      .filter((l) => {
        const disabled = this.checkDisabledPlacement(l);
        return !(disabled.replaced || disabled.deactivated);
      }).concat(
        optionalLinesToDeactivate.filter(plc => isPlcActive(findConfLine(plc)))
      );
    const unActiveToDeactivate = allPlacementsToDeactivate.filter(plc => !this.placementsToAskDeactivate.includes(plc));

    if (this.askToDeactivateModel && this.placementsToAskDeactivate.length > 0) {
      this.dialog.open(this.askToDeactivateModel)
        .afterClosed()
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
          if (res === 'deactivate') {
            this.configuration.removeSelectedMaterialColor(placementIds, idGroups);
            this.goToSchermataDiConfigurazione();
            if (!(optionalLinesToDeactivate as ConfigurabilityCommercialLines[]).includes(this.placementsToAskDeactivate[0])) {
              this.clickSuPlacement(this.placementsToAskDeactivate[0], !this.placementsToAskDeactivate[0].placementId, 'GROUP_ID-' + (this.modelConfiguration?.tabSelezionato || ConfigurationTab.UNGROUPED));
            } else {
              this.configuraPlacementOpzionale(this.placementsToAskDeactivate[0] as PlacementOptional);
            }
          } else if (res === 'reset') {
            this.configuration.historyAction.next({message: HistoryMessage.Recover});
            this.goToSchermataDiConfigurazione(true);
          }
        });
    } else if (unActiveToDeactivate.length > 0) {
      const unActivePlcIds = unActiveToDeactivate.map(plc => plc.placementId).filter(plcId => plcId) as number[];
      const unActiveIdGroups = unActiveToDeactivate.map(plc => !plc.placementId && plc.idGroup).filter(idGroup => idGroup) as number[];
      this.configuration.removeSelectedMaterialColor(unActivePlcIds, unActiveIdGroups);
      this.goToSchermataDiConfigurazione();
    }
    this.cd.markForCheck();
  }

  private goToSchermataDiConfigurazione(avoidUpdateHistory = false): void {
    this.ngZone.run(() => {
      // const previousView = this.view;
      this.view = ConfigurationView.CONFIGURATION_SUMMARY;
      this.currentPlacementConfiguration = {};
      this.selectedWidgetConfiguration = null;
      this.selectedWidget = null;
      if (this.saved) {
        this.configurationId = null;
        /*
                if (this.modelConfiguration) {
                  this.modelConfiguration.configurationId = null;
                }
        */
        this.saved = false;
      }
      this.workingPlacement = null;
      this.currentRule = undefined;
      this.headerService.header.next(HeaderStep.CONFIGURATION);
      if (!avoidUpdateHistory) {
        this.configuration.updateHistoryIfNecessary();
      }
      this.showSaveEditing = true;
      this.cd.markForCheck();
      this.afterViewChecked$.pipe(first(), takeUntil(this.destroy$))
        .subscribe(() => this.scrollToSummary());
      /*
            if (previousView === ConfigurationView.CONFIGURATION_WIDGET && !shouldNotUpdateVesta) {
              this.configuration.aggiornaVesta();
            }
      */
    });
  }

  private updateAfterSavingConf(configurationId: number): void {
    this.takeScreenshot()
      .then(() => this.saveConfigurationImage(configurationId));
    const body = {productId: Number(this.productId)};
    this.getProductInfo(body);
    this.aggiornaConfigurazioni();
  }

  public selectMutuallyExclusiveOptions(placement: MutuallyExclusive, groupedMutually?: MutuallyExclusiveGrouped): void {
    let allSelected = false;
    if ('materialCode' in placement && placement?.materialCode && placement?.placementType === PlacementType.SINGLE) {
      this.currentPlacementConfiguration?.mutuallyExclusiveOptions?.ungrouped?.map((conf: MutuallyExclusive) => {
        conf.selected = false;
        return conf;
      });
      placement.selected = true;
      allSelected = true;
    } else if (placement?.placementType === PlacementType.GROUP) {
      groupedMutually?.mutuallyExclusiveOptions?.map((conf: MutuallyExclusive) => {
        conf.selected = false;
        return conf;
      });
      placement.selected = true;
      allSelected = this.currentPlacementConfiguration?.mutuallyExclusiveOptions?.grouped?.every(conf =>
        !conf.mutuallyExclusiveOptions?.length || conf.mutuallyExclusiveOptions.some(mutually => mutually.selected)
      ) !== false;
    }
    if (this.currentPlacementConfiguration.mutuallyExclusiveOptions && allSelected) {
      this.ottieniConfigurabilitaPlacement(this.currentPlacementConfiguration.mutuallyExclusiveOptions.configurabilityBody, this.currentPlacementConfiguration.mutuallyExclusiveOptions.configurabilityPlacement);
    }
  }

  public extractSeparatedLabels(label?: string): (string | undefined)[] {
    if (label?.split('/')?.length) {
      return label?.split('/');
    } else {
      return [label];
    }
  }

  public selectMacroMaterialConfiguration(configuration: WidgetConfiguration): void {
    if (configuration?.widgetCode) {
      this.selectedWidget = configuration.widgetCode;
      if (!this.workingPlacement?.opzionale) {
        this.selectedWidgetConfiguration = configuration;
      } else {
        this.selectedWidgetConfiguration = {...configuration, ...{opzionale: true}};
      }
      this.setRuleInfo();
      this.currentPlacementConfiguration?.configurationList?.map((conf: WidgetConfiguration) => {
        conf.selected = false;
        return conf;
      });
      configuration.selected = true;
    }
    this.cd.markForCheck();
  }

  public scrollToSummary(): void {
    if (this.endColumn) {
      // this.configurationsComponent?.forEach((conf: ModelConfigurationsComponent) => conf.collapseAll()); // TODO: remove accordion animation, because it goes conflict wit scroll animation
      // fixes accordion animations latency
      setTimeout(() => {
        this.endColumn?.nativeElement.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        });
      }, 100);
    }
  }

  public mutuallyPlacementWithoutMaterialAndColor(): PlacementConfiguration | null {
    const mutuallySelected = this.currentPlacementConfiguration.mutuallyExclusiveOptions?.ungrouped?.find((obj: MutuallyExclusive) => {
      return obj.selected === true;
    });
    if (mutuallySelected) {
      const configuration = this.currentPlacementConfiguration.mutuallyExclusiveOptions?.configurabilityPlacement;
      const confLineId = Array.isArray(mutuallySelected.placementOptionConfLineIds) ? mutuallySelected.placementOptionConfLineIds[0] : mutuallySelected.placementOptionConfLineIds;
      return this.configuration.createMockPlacementSelezionato({
        ...configuration,
        placementConfLineId: confLineId,
        vestaExternalId: mutuallySelected.vestaExternalId,
        placementName: mutuallySelected.optionDescription,
        optionDescription: mutuallySelected.optionDescription,
        placementList: undefined
      });
    } else {
      return null;
    }
  }

  public configurazionePlacement(placementSelezionato: PlacementConfiguration): void {
    this.lastConfiguredPlacements = [
      {
        placementId: placementSelezionato.configuration.placementId || undefined,
        idGroup: placementSelezionato.configuration.idGroup || undefined
      },
      ...this.lastConfiguredPlacements.filter((p) => !CrossRestrictionUtils.isMatchPlacement(p, placementSelezionato.configuration))
    ];
    if (this.workingPlacement?.currentName && isSinglePlacement(this.workingPlacement)) { // placementName only in singlePlacement
      this.workingPlacement.placementName = this.workingPlacement.currentName;
    }
    placementSelezionato.configuration.active = true;
//    this.visualizzaSchermataDiConfigurazione(true);
    this.configuration.configuraPlacement(placementSelezionato, stringToConfigurationTabType(this.modelConfiguration?.tabSelezionato || ConfigurationTab.UNGROUPED), placementSelezionato.configuration?.opzionale);
    if (this.enableVesta) {
      this.toggleRightCol();
    }
  }

  public checkPlacementConf(placement: ConfigurabilityCommercialLines | ConfigurabilityGroup | BoxedStructure | PlacementOptional, what?: PlacementInfo | undefined, optional?: boolean): any {
    if (optional && isBoxedStructure(placement)) {
      return this.configuration.checkBoxedPlacementConfigured(placement);
    } else if (!isBoxedStructure(placement)) {
      const placementConf = this.configuration.cercaPlacementConfigurato(placement);
      if (placementConf) {
        return this.configuration.extractPlacementInfo(what, placementConf, optional);
      }
    }
    return false;
  }

  public getNoConfigurationLines(): boolean {
    const noUngrouped = !this.product?.configurability?.ungrouped ||
      this.product.configurability.ungrouped.reduce((s: number, v: ConfigurabilityUngrouped) =>
        s + v.ungroupedElements?.filter(el => !this.isPlacementHidden(el)).length || 0, 0) === 0;
    const noGrouped = !this.returnProductGroups() || this.returnProductGroupsLength() === 0;
    const noBoxed = !this.product?.optionalConfigurability?.boxed ||
      this.product.optionalConfigurability.boxed.reduce((s: number, v: BoxedStructure) => s + v.placementOptionalList?.length || 0, 0) === 0;
    const noUnboxed = !this.product?.optionalConfigurability?.unboxed || this.product?.optionalConfigurability?.unboxed.length === 0;
    return noUngrouped && noGrouped && noBoxed && noUnboxed;
  }

  public returnProductGroups(): ConfigurabilityGroup[] {
    return this.product?.configurability?.groups || [];
  }

  public returnProductGroupsLength(): number {
    return this.product?.configurability?.groups?.length || 0;
  }

  public returnProductUngroupedLabel(): string {
    return this.product.configurability?.ungrouped?.[0].nameGroup || 'RIVESTIMENTO_SEPARATO';
  }

  public saveConf(dialog: boolean): void {
    if (dialog && this.saveConfModal) {
      this.dialog.open(this.saveConfModal);
    } else {
      this.dialog.closeAll();
      this.loaded = false;
      this.orderService.saveConfiguration({
        configurationId: this.configurationId,
        default: this.default,
        configurationName: this.configurationName
      }).pipe(takeUntil(this.destroy$)).subscribe((data) => {
        if (data?.error) {
          this.common.showErrorToast(data?.error);
        } else {
          this.saved = true;
          if (this.configurationId) {
            this.updateAfterSavingConf(this.configurationId);
          }
        }
        this.loaded = true;
      });
    }
  }

  public addConfToOrder(): void {
    this.loaded = false;
    this.takeScreenshot().then(() => {
      this.loaded = true;
      if (this.authService.currentUserPermission.canHaveManyEditableProforma) {
        const result = this.openAddToOrderComponent({
          ...this.summaryData,
          configurationId: null,
          screenshot: this.screenshot
        });
        result.observable.pipe(
          filter(({shouldAddToProforma, createNewOrder}) => shouldAddToProforma),
          takeUntil(this.destroy$)
        ).subscribe(({shouldAddToProforma, createNewOrder}) => {
          this.getSummaryAndAddToProforma(createNewOrder).then((data) => {
            if (data?.error) {
              this.common.showErrorToast(data?.error);
            }
            result.dialog.close();
          });
        });
      } else {
        this.loaded = false;
        this.getSummaryAndAddToProforma(!this.orderService.currentOrder).then((data) => {
          this.loaded = true;
          if (data?.error) {
            this.common.showErrorToast(data?.error);
          }
        });
      }
    });
  }

  public getSummaryAndAddToProforma(createNewOrder: boolean): Promise<{ error?: any } | undefined> {
    return this.getSummary(null, true)
      .then((summaryData: any) => this.saveConfigurationImage(summaryData.configurationId).then(() => summaryData))
      .then((summaryData: any) =>
        this.orderService.updateCurrentOrder().pipe(
          switchMap(() => this.createOrAddToProforma(createNewOrder, summaryData.configurationId))
        ).toPromise())
      .then((data: any) => {
        this.cd.markForCheck();
        return data;
      });
  }

  private openAddToOrderComponent(summaryData: any): {dialog: any, observable: Observable<{shouldAddToProforma: boolean, createNewOrder: boolean}>} {
    const dialogRef = this.dialog.open(AddToOrderComponent, {
      height: '92vh',
      width: '70vw',
      panelClass: ['custom-dialog-container', 'full-screen-dialog-responsive']
    });
    dialogRef.componentInstance.product = summaryData;
    dialogRef.componentInstance.configurationId = [summaryData.configurationId];
    this.showSaveEditing = false;
    this.singleConfigurationId = summaryData.configurationId;
    this.cd.markForCheck();
    return {dialog: dialogRef, observable: dialogRef.componentInstance.orderSelected};
  }

  private createOrAddToProforma(createNewOrder: boolean, configurationId: number): Observable<any> {
    const order = createNewOrder || !this.orderService.currentOrder || !isMutableOrderState(this.orderService.currentOrder.stateKey)
      ? null : this.orderService.currentOrder;
    const createOrderParams: any = {
      customerId: this.orderService.currentClient?.id,
      opportunityId: this.orderService.currentOpportunity?.id,
      configurationId,
      orderId: order && order.id ? order.id : null,
      etoId: this.etoId ? +this.etoId : null
    };
    if (order?.id && !this.etoId) {
      return this.orderService.orderLineCreate(createOrderParams).pipe(
        tap(() => {
          this.currentOrderId = order.id;
          this.openProformaDetail();
          this.cd.markForCheck();
      }));
    } else if (order?.id && this.etoId) {
      return this.orderService.orderEtoUpdate(createOrderParams).pipe(tap(() => {
        this.currentOrderId = order.id;
        this.openProformaDetail();
        this.cd.markForCheck();
      }));
    } else {
      return this.orderService.orderCreate(createOrderParams).pipe(tap(
        (data) => {
          this.orderService.order = data;
          this.cd.markForCheck();
        }, (error) => {
        }, () => {
          this.orderService.refreshConfiguration();
          this.currentOrderId = this.orderService.order?.id || null;
          this.openProformaDetail();
          this.cd.markForCheck();
        }
      ));
    }
  }

  public resetConfigurationChanges(): void {
    this.db.resetHistory();
    const prebuilt = (this.product.configurazioniPrebuilt || []).find((config: ModelPrebuiltConfiguration) => config.default);
    if (prebuilt) {
      this.applyConfiguration(prebuilt);
    }
  }

  public aggiornaConfigurazioni(): void {
    this.estraiConfigurazioniPrebuilt({productId: Number(this.productId)})
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (!this.etoFlow) {
          this.estraiListaConfigurazioniSalvate();
        }
      });
  }

  public controllaDifferenzaColore(placement: ConfigurabilityCommercialLines | ConfigurabilityGroup, remove?: boolean, event?: MouseEvent): boolean {
    if (placement.rulesList && placement.rulesList.length > 0) {
      return false;
    }
    const placementConf = this.configuration.cercaPlacementConfigurato(placement);
    const placementOriginale = this.configuration.cercaPlacementConfigurato(placement, true);
    if (!remove) {
      if (!placementOriginale) {
        return true;
      } else {
        return this.configuration.controllaSeColorePlacementDifferente(placementConf, placementOriginale);
      }
    } else {
      this.configuration.rimuoviColoreSelezionato(placementConf, placementOriginale);
      if (event) {
        event.stopPropagation();
      }
    }
    return false;
  }

  public findConfigurability(): boolean {
    return !(this.returnProductGroupsLength() === 0 && (!this.product?.configurability?.ungrouped || this.product?.configurability?.ungrouped?.length > 0));
  }

  public checkIfCanBuildNewPrebuilt(): boolean {
    return this.authService.currentUserPermission.canModifyAllConfigurations;
  }

  public get canRequestEto(): boolean {
    return this.authService.currentUserPermission.canRequestEto;
  }

  public blockIfEtoCantRequested(): boolean {
    return !!this.summaryData?.eto && !this.canRequestEto;
  }

  // TODO: da modificare per i boxed
  public updateOptionalConfigurability(): void {
    const oldOptionalConfigurability = this.product.optionalConfigurability;
    const ottieniStrutturaOpzionaleOriginale = this.configuration.strutturaOpzionaleCompatta;
    if (this.modelConfiguration && this.modelConfiguration.tabSelezionato !== ConfigurationTab.UNGROUPED && ottieniStrutturaOpzionaleOriginale !== null) {
      let disabledConfigurability: PlacementOptional[] = [];
//      Object.keys(ottieniStrutturaOpzionaleOriginale).forEach((key: any) => {
      this.product.optionalConfigurability = {
        [BoxedType.UNBOXED]: ottieniStrutturaOpzionaleOriginale[BoxedType.UNBOXED].filter((filteredEl: PlacementOptional) =>
          filteredEl.hideIfGroupSelected !== +(this.modelConfiguration?.tabSelezionato || -1)),
        [BoxedType.BOXED]: ottieniStrutturaOpzionaleOriginale[BoxedType.BOXED]
      };
      disabledConfigurability = disabledConfigurability.concat(ottieniStrutturaOpzionaleOriginale[BoxedType.UNBOXED].filter((filteredEl: PlacementOptional) =>
        filteredEl.hideIfGroupSelected === +(this.modelConfiguration?.tabSelezionato || -1)));
//        }
//      );
      if (disabledConfigurability.length > 0) {
        this.configuration.disablePlacementList(disabledConfigurability);
      }
    } else {
      this.product.optionalConfigurability = ottieniStrutturaOpzionaleOriginale || undefined;
    }
    if (this.product.optionalConfigurability !== oldOptionalConfigurability) {
      this.optionalsBoxedUnboxed = [
        ...(this.product.optionalConfigurability?.[BoxedType.BOXED] || []).map(boxed => ({
          type: BoxedType.BOXED as BoxedType.BOXED,
          index: Math.min(...boxed.placementOptionalList.map((o) => o.index)),
          optional: boxed
        })),
        ...(this.product.optionalConfigurability?.[BoxedType.UNBOXED] || []).map(unboxed => ({
          type: BoxedType.UNBOXED as BoxedType.UNBOXED,
          index: unboxed.index,
          optional: unboxed
        }))
      ];
    }
    this.noConfigurationLines = this.getNoConfigurationLines();
    this.cd.markForCheck();
  }

  public hasAtLeastOneEtoLine(): any {
    const elements = [...this.configuration.strutturaConfigurata.elementi, ...this.configuration.strutturaConfigurata.opzionali];
    return elements.some(el => el.selectedMaterialColor.eto);
  }

  public downloadPdf(base64String: string, fileName: string): void {
    const source = `data:application/pdf;base64,${base64String}`;
    const link = document.createElement('a');
    link.href = source;
    link.download = `${fileName}.pdf`;
    link.click();
  }

  public checkAuth(): boolean {
    return this.authService.isUserAuthenticated;
  }

  public shouldOverviewButtonVisible(): boolean {
    return !!this.modelConfiguration &&
      !!this.modelConfiguration.productId &&
      this.loaded;
  }

  public checkActiveOptional(placement: ConfigurabilityCommercialLines): string {
    if ('optionalReplaceList' in placement && placement.optionalReplaceList) { // optionalReplaceList only for single Placement
      const optional = this.configuration.strutturaModelloConfigurata.find((element: VirginStructureConfigurata) => placement.optionalReplaceList.includes(element.placementId) && element.active);
      if (optional) {
        const boxedId = optional.optionalElementInfo?.boxedId;
        const box = this.configuration.strutturaOpzionaleOriginale?.[BoxedType.BOXED].find((boxed) => boxed.boxId === boxedId);
        return box ? box.boxName : optional.placementName;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  public checkDisabledPlacement(placement: ConfigurabilityCommercialLines | ConfigurabilityGroup): { replaced?: string, deactivated?: string, sameConfigurationOf?: string } {
    return {
      replaced: placement.placementType !== PlacementType.GROUP ? this.checkActiveOptional(placement) : '',
      deactivated: this.checkDisabledWith(placement),
      sameConfigurationOf: CrossRestrictionUtils.getMasterNameConfiguredWithForceSameConfiguration(placement, this.configuration.getAllElementsForSummary)
    };
  }

  public workingPlacementName(): string | null {
    if (this.workingPlacement && 'nameGroup' in this.workingPlacement && this.workingPlacement.nameGroup) { // removed && !('placementName' in this.workingPlacement && this.workingPlacement.placementName)
      return this.workingPlacement.nameGroup;
    } else if (this.workingPlacement && 'currentName' in this.workingPlacement && this.workingPlacement.currentName) { // removed !('nameGroup' in this.workingPlacement && this.workingPlacement.nameGroup) &&
      return this.workingPlacement.currentName;
    } else if (this.workingPlacement && 'placementName' in this.workingPlacement && this.workingPlacement.placementName) { // TODO: rivedere placementName & currentName per i grouped
      return this.workingPlacement.placementName;
    } else {
      return null;
    }
  }

  public getBackgroundImageForSlide(slide: string): string {
    return this.repairUrl.transform(slide);
  }

  public nameForPlacement(placement: ConfigurabilityCommercialLines): string {
    const found = this.checkPlacementConf(placement, PlacementInfo.FOUND);
    const mutuallyName = this.checkPlacementConf(placement, PlacementInfo.PLACEMENT_MUTUALLY_EXCLUSIVE_NAME);
    if (!found || !mutuallyName) {
      return placement.placementName;
    } else {
      return mutuallyName;
    }
  }

  public mainMutuallyNameForPlacementId(placementId: number): string {
    const configurabilityPlacement = this.currentPlacementConfiguration?.mutuallyExclusiveOptions?.configurabilityPlacement;
    if (configurabilityPlacement) {
      const placement = this.searchPlacementInGroup(placementId, configurabilityPlacement);
      return placement?.placementName || '';
    }
    return '';
  }

  public mutuallyExclusiveOptionsGroupedLength(): number {
    return (this.currentPlacementConfiguration?.mutuallyExclusiveOptions?.grouped || []).length;
  }

  public isPlacementHidden(placement: ConfigurabilityCommercialLines | StrutturaElemento): boolean {
    if (placement.placementType === PlacementType.SINGLE) {
      return placement.hideInConfigurationBar || false;
    } else {
      return (placement.placementList as ConfigurabilityCommercialLines[])?.every((plc: ConfigurabilityCommercialLines | MutuallyExclusivePlacementList) =>
        ('hideInConfigurationBar' in plc && plc.hideInConfigurationBar) || ('isOptional' in plc && plc.isOptional) || false) || false;
    }
  }

  private async isHistoryEmpty(): Promise<boolean> {
    if (this.productId) {
      const current = (await this.db.getCurrentIndex(+this.productId) || {current: 0}).current;
      const firstId = (await this.db.firstStructureFor(+this.productId) || {historyId: 0}).historyId;
      const lastStructure = (await this.db.lastStructureFor(+this.productId) || {historyId: 0, isWaitingStructure: true});
      const last = lastStructure.historyId;
      return firstId === current && last === current &&
        (lastStructure.isWaitingStructure || lastStructure.isWaitingStructure === undefined);
    } else {
      return true;
    }
  }

  private modelConfigurationReset(): void {
    this.configuration.resetAll();
    this.product = {};
    this.modelConfiguration = undefined;
  }

  private checkExclusive(body: BodyInterface, placement: ConfigurabilityCommercialLines | ConfigurabilityGroup | PlacementOptional, optional?: boolean): void {
    optional = !!optional;
    if (!('hasMutuallyExclusiveOption' in placement) || placement.hasMutuallyExclusiveOption) {
      this.loaded = false;
      this.modelService.checkExclusive(body).pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.loaded = true;
        if (placement?.placementType === PlacementType.SINGLE && data?.mutuallyExclusiveOptions?.length > 0) {
          this.handleMutually(placement, body, optional);
          if (this.currentPlacementConfiguration.mutuallyExclusiveOptions) {
            this.currentPlacementConfiguration.mutuallyExclusiveOptions.ungrouped = data?.mutuallyExclusiveOptions;
          }
        } else if (placement?.placementType === PlacementType.GROUP && data?.groupedPlacement?.length > 0) {
          this.handleMutually(placement, body, optional);
          if (this.currentPlacementConfiguration.mutuallyExclusiveOptions) {
            this.currentPlacementConfiguration.mutuallyExclusiveOptions.grouped = data?.groupedPlacement
              .filter((grouped: MutuallyExclusiveGrouped) => grouped.mutuallyExclusiveOptions?.length);
          }
        } else {
          this.ottieniConfigurabilitaPlacement(body, placement, optional);
        }
        this.cd.markForCheck();
      });
    } else {
      this.ottieniConfigurabilitaPlacement(body, placement, optional);
    }
  }

  private estraiListaConfigurazioniSalvate(): void {
    this.estraiConfigurazioniSalvate({productId: Number(this.productId), myConfigurations: true});
    if (this.orderService.currentClient && this.authService.currentUserPermission.hasMoreClients) {
      const customerId = this.orderService.currentClient.id;
      this.estraiConfigurazioniSalvate({productId: Number(this.productId), customerId, myConfigurations: false});
    }
    if (this.orderService.currentOrder) {
      const orderId = this.orderService.currentOrder.id;
      this.estraiConfigurazioniSalvate({productId: Number(this.productId), orderId, myConfigurations: false});
    }
    if (this.singleConfigurationId) {
      if (!this.recoveringConfiguration) {
        this.estraiConfigurazioniSalvate({
          productId: Number(this.productId),
          singleConfigurationId: this.singleConfigurationId
        });
      } else {
        this.estraiConfigurazioniSalvate({
          productId: Number(this.productId),
          copyConfigurationId: this.singleConfigurationId
        });
      }
    }
  }

  private update(): void {
    this.configurationUpdate$ = this.common.configurationUpdate
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: { event: ConfigurationUpdate }) => {
        switch (data?.event) {
          case ConfigurationUpdate.CONFIGURABILITA_CARICATA:
            if (this.productId && this.bomId) {
              this.aggiornaConfigurazioni();
              if (this.orderService.copyConfigurationId) {
                this.estraiConfigurazioniSalvate({
                  productId: Number(this.productId),
                  copyConfigurationId: this.orderService.copyConfigurationId
                });
              }
              this.product.configurability = this.configuration.ottieniStrutturaOriginale;
              this.noConfigurationLines = this.getNoConfigurationLines();
              this.updateOptionalConfigurability();
              this.configuration.inizializzaStrutturaVesta(this.estraiStrutturaTabSelezionato());
              this.loaded = true;
              this.configurationUpdate$.unsubscribe();
            }
            break;
          default:
            break;
        }
      });
  }

  private ottieniPrebuiltId(): number | null {
    const strutturaApplicata = this.configuration.ottieniStrutturaApplicata;
    if (strutturaApplicata && strutturaApplicata.isPrebuilt && strutturaApplicata.originalPrebuiltId) {
      return strutturaApplicata.originalPrebuiltId;
    } else {
      return null;
    }
  }

  private estraiDatiSummary(configurationId: number | null): any {
    return {
      productId: Number(this.productId),
      partnerId: this.orderService.currentClient?.id || null,
      configurationId,
      originalPrebuiltId: this.ottieniPrebuiltId(),
      editing: this.modelConfiguration?.editing ? this.modelConfiguration?.editing : false,
      newPrebuilt: this.modelConfiguration?.newPrebuilt,
      selectedConfigurations: this.configuration.strutturaElementiperRiepilogo
    };
  }

  private estraiStrutturaTabSelezionato(): ConfigurabilityCommercialLines[] | undefined {
    return this.configuration.strutturaOriginalePerTab(stringToConfigurationTabType(this.modelConfiguration?.tabSelezionato || ConfigurationTab.UNGROUPED));
  }

  private getAllPlacementsForCurrentTab(): ConfigurabilityCommercialLines[] {
    const strutturaTab = this.estraiStrutturaTabSelezionato() || [];
    const optionals = this.product.optionalConfigurability ? this.product.optionalConfigurability[BoxedType.UNBOXED]
      .concat(this.product.optionalConfigurability[BoxedType.BOXED]
        .reduce((acc, boxed) => acc.concat(boxed.placementOptionalList), [] as PlacementOptional[])) : [];
    return strutturaTab.concat(optionals);
  }

  private handleMutually(placement: ConfigurabilityCommercialLines | ConfigurabilityGroup | PlacementOptional, body: BodyInterface, optional?: boolean): void {
    this.currentPlacementConfiguration.mutuallyExclusiveOptions = {
      configurabilityPlacement: placement,
      configurabilityBody: body,
      ungrouped: undefined,
      grouped: []
    };
    this.view = ConfigurationView.CONFIGURATION_WIDGET;
    this.headerService.header.next(HeaderStep.ELEMENTS);
    this.workingPlacement = placement;
    if (isSinglePlacement(this.workingPlacement)) {
      this.workingPlacement.currentName = this.workingPlacement.placementName;
    }
    this.workingPlacement.opzionale = !!optional;
  }

  private ottieniConfigurabilitaPlacement(body: BodyInterface, placement: ConfigurabilityCommercialLines | ConfigurabilityGroup | PlacementOptional, opzionale?: boolean): void {
    if (isGroupPlacement(placement) || (isSinglePlacement(placement) && placement.configurableElement)) {
      this.loaded = false;
      const ruleInfo = CrossRestrictionUtils.getConfigurabilityRuleInfoForPlacement(placement, this.configuration.getAllElementsForSummary);
      if (ruleInfo.length > 0) {
        body = {...body, ruleList: ruleInfo};
      }
      this.modelService.ottieniConfigurabilitaPlacement(body)
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
          this.loaded = true;
          if (data?.error) {
            this.common.showErrorToast(data?.error);
          } else if (data?.configurationList?.length > 0) {
            this.view = ConfigurationView.CONFIGURATION_WIDGET;
            this.currentPlacementConfiguration.configurationList = data.configurationList;
            if (!opzionale) {
              this.workingPlacement = placement;
              if (isSinglePlacement(this.workingPlacement)) {
                this.workingPlacement.currentName = this.workingPlacement.placementName;
              }
              if (placement?.placementType === PlacementType.SINGLE && this.currentPlacementConfiguration.mutuallyExclusiveOptions?.ungrouped && this.currentPlacementConfiguration.mutuallyExclusiveOptions.ungrouped.length > 0) {
                this.gestisciPlacementSingoliMutualmenteEsclusivi();
              } else if (placement?.placementType === PlacementType.GROUP && this.currentPlacementConfiguration.mutuallyExclusiveOptions?.grouped && this.currentPlacementConfiguration.mutuallyExclusiveOptions.grouped.length > 0) {
                this.gestisciPlacementRaggrupatiMutualmenteEsclusivi();
              }
            } else {
              this.workingPlacement = placement;
              this.workingPlacement.opzionale = true;
              if (isSinglePlacement(this.workingPlacement)) {
                this.workingPlacement.currentName = this.workingPlacement.placementName;
              }
            }
            if (this.currentPlacementConfiguration?.configurationList?.length === 1) {
              this.selectMacroMaterialConfiguration(this.currentPlacementConfiguration.configurationList[0]);
            }
            if (data?.componentsToHide?.length > 0) {
              this.common.vestaInput.next({configurations: data?.componentsToHide, multiple: true, remove: true});
            }
            this.headerService.header.next(HeaderStep.ELEMENTS);
            this.cd.markForCheck();
          }
        });
    } else {
      const placementSelezionato = this.mutuallyPlacementWithoutMaterialAndColor();
      if (placementSelezionato) {
        if (this.workingPlacement && placementSelezionato.configuration.placementName && isSinglePlacement(this.workingPlacement)) {
          this.workingPlacement.currentName = placementSelezionato.configuration.placementName;
        }
//      this.vestaService.aggiornaPlacementTemporaneo(placementSelezionato);
        if (this.checkIfMutuallyExclusiveSelected()) {
          this.configurazionePlacement(placementSelezionato);
        }
        this.cd.markForCheck();
      }
    }
  }

  private gestisciPlacementRaggrupatiMutualmenteEsclusivi(): void {
    if (this.currentPlacementConfiguration.mutuallyExclusiveOptions?.grouped) {
      for (const groupedMutually of this.currentPlacementConfiguration.mutuallyExclusiveOptions?.grouped) {
        const mutuallySelected = groupedMutually.mutuallyExclusiveOptions?.find((placement: MutuallyExclusive) => {
          return placement.selected === true;
        });
        if (mutuallySelected) {
          const confLineId = Array.isArray(mutuallySelected.placementOptionConfLineIds) ? mutuallySelected.placementOptionConfLineIds[0] : mutuallySelected.placementOptionConfLineIds;
          this.currentPlacementConfiguration?.configurationList?.forEach(widgetConfiguration => {
            const mutuallyPlc = widgetConfiguration.placementList?.find(plc =>
              plc.placementId === groupedMutually.placementId
            );
            if (mutuallyPlc) {
              mutuallyPlc.placementConfLineId = confLineId;
              mutuallyPlc.vestaExternalId = mutuallySelected.vestaExternalId;
              mutuallyPlc.placementName = mutuallySelected.optionDescription;
            }
          });
        }
      }
    }
  }

  private gestisciPlacementSingoliMutualmenteEsclusivi(): void {
    const plc = (this.currentPlacementConfiguration.mutuallyExclusiveOptions?.ungrouped || []).find((obj: MutuallyExclusive) => {
      return obj.selected === true;
    });
    if (plc) {
      this.currentPlacementConfiguration.configurationList = this.currentPlacementConfiguration.configurationList?.map((configuration: WidgetConfiguration) => {
        if (configuration?.placementConfLineId === plc.placementOptionConfLineIds) { // TODO: check if array?
          configuration.vestaExternalId = plc.vestaExternalId;
          configuration.placementName = plc.optionDescription;
          configuration.optionDescription = plc.optionDescription;
        }
        return configuration;
      });
      this.currentPlacementConfiguration.configurationList = (this.currentPlacementConfiguration.configurationList || []).filter((configuration: WidgetConfiguration) => {
        return configuration?.placementConfLineId === plc.placementOptionConfLineIds; // TODO: check if array?
      });
      if (this.workingPlacement && isSinglePlacement(this.workingPlacement)) { // placementName only in singlePlacement
        this.workingPlacement.currentName = plc.optionDescription;
      }
    }
  }

  private checkIfAllElementsAreSelected(): boolean {
    const tabSelezionato: ConfigurationTabType = stringToConfigurationTabType(this.extractSelectedTab(false));
    const strutturaPrincipale: ConfigurabilityStructure = JSON.parse(JSON.stringify(this.configuration.ottieniStrutturaOriginale));
    const listaCompletaPlacement = this.configuration.estraiPlacementDallaStrutturaPrincipale(tabSelezionato, strutturaPrincipale)
      .filter(plc => !this.isPlacementHidden(plc) && this.isConfigurableElement(plc));
    const listaPlacementConfigurati = this.configuration.ottieniStrutturaConfigurata
      .filter(plc => !this.isPlacementHidden(plc.configuration));
    const listaPlacementOpzionaliReplace = this.configuration.ottieniStrutturaConfigurataOpzionaliByType(OptionalType.REPLACE);
    const listaPlacementOpzionaliAdd = this.configuration.ottieniStrutturaConfigurataOpzionaliByType(OptionalType.ADD);
    const opzionaliAddNonConfigurati: ConfigurationMaterialColor<StrutturaOpzionale>[] = listaPlacementOpzionaliAdd.filter((item: ConfigurationMaterialColor<StrutturaOpzionale>) => {
      return item.configuration?.optionalElementInfo?.configurable && !item?.selectedMaterialColor?.color?.colorId; // optionalElementInfo.configurable only in prebuilt
    });
    const deactivatedPlacements = [
      ...listaPlacementOpzionaliReplace.map(conf => conf.configuration.placementToReplace),
      ...listaPlacementOpzionaliAdd.concat(listaPlacementOpzionaliReplace)
        .reduce((acc, curr) => acc.concat(curr.configuration.placementToDeactivateList || []), [] as number[])
    ];
    const deactivatedGroups = listaPlacementOpzionaliAdd.concat(listaPlacementOpzionaliReplace)
      .reduce((acc, curr) => acc.concat(curr.configuration.groupToDeactivateList || []), [] as number[]);
    const opzionaliReplaceNonConfigurati: ConfigurationMaterialColor<StrutturaOpzionale>[] = listaPlacementOpzionaliReplace.filter((item: ConfigurationMaterialColor<StrutturaOpzionale>) => {
      return item.configuration?.optionalElementInfo?.configurable && !item?.selectedMaterialColor?.color?.colorId; // TODO: optionalElementInfo.configurable only in prebuilt
    });
    const anyObjNotConfigured = listaCompletaPlacement?.some(plc => {
      if (plc.placementType === PlacementType.SINGLE) {
        return !listaPlacementConfigurati?.find(item => plc.placementId === item.configuration?.placementId)
          && !deactivatedPlacements.includes(plc.placementId);
      } else {
        return !listaPlacementConfigurati?.find(item => plc.idGroup === item.configuration?.idGroup)
          && !deactivatedGroups.includes(plc.idGroup);
      }
    });
    return opzionaliAddNonConfigurati?.length === 0 && opzionaliReplaceNonConfigurati?.length === 0 && (listaCompletaPlacement?.length === 0
      || !anyObjNotConfigured);
  }

  private setConfigurationEditing(configuration: ModelPrebuiltConfiguration, list: ModelPrebuiltConfiguration[]): void {
    for (const conf of list) {
      if (conf.configurationId === configuration.configurationId) {
        conf.editing = true;
      }
    }
  }

  private extractSelectedTab(returnStructure: boolean | undefined, tab?: string): string {
    let tabSelezionato = String(ConfigurationTab.UNGROUPED);
    if (!returnStructure) {
      tabSelezionato = this.modelConfiguration?.tabSelezionato ? this.modelConfiguration.tabSelezionato : ConfigurationTab.UNGROUPED;
    } else if (tab) {
      tabSelezionato = tab;
    }
    return tabSelezionato;
  }

  private selezionaTabPerConfigurazione(configuration: ModelPrebuiltConfiguration): void {
    if (configuration?.firstLevelOptGroup && this.tabGroup?._allTabs && this.tabGroup?._allTabs?.length > 0) {
      const checkLabel = String(configuration?.firstLevelOptGroup);
      const correctTab = this.tabGroup?._allTabs.find((tab: MatTab) => {
        const separatedGroupLabel = tab?.ariaLabel?.split('-');
        if (separatedGroupLabel && separatedGroupLabel.length > 1) {
          return String(separatedGroupLabel[1]) === checkLabel;
        } else {
          return false;
        }
      });
      if (correctTab?.position) {
        if (this.modelConfiguration) {
          this.modelConfiguration.tabSelezionato = checkLabel;
        }
        this.currentTabIndex = correctTab.position;
      }
    } else {
      if (this.modelConfiguration) {
        this.modelConfiguration.tabSelezionato = ConfigurationTab.UNGROUPED;
      }
      this.currentTabIndex = 0;
    }
  }

  private handleVestaClickGrouped(externalId: string): void {
    let clickedPlacement: ConfigurabilityCommercialLines | undefined;
    let foundInGroup = false;
    let found: ConfigurabilityCommercialLines | undefined;
    if (this.product?.configurability && this.product?.configurability?.groups?.length > 0) {
      for (const group of this.product?.configurability?.groups) {
        if (String(group?.idGroup) === this.modelConfiguration?.tabSelezionato) {
          found = group.ungroupedElements?.find((plc: ConfigurabilityCommercialLines) => {
            return plc.vestaExternalId === externalId;
          });
          if (found) {
            clickedPlacement = found;
          } else {
            if (group.groupedElements?.length > 0) {
              for (const placement of group.groupedElements) {
                if (!clickedPlacement) {
                  if (placement?.placementType === PlacementType.GROUP && placement?.placementList?.length > 0) {
                    found = placement?.placementList?.find((plc: ConfigurabilityCommercialLines) => {
                      return plc.vestaExternalId === externalId;
                    });
                    if (found) {
                      foundInGroup = true;
                    }
                  } else if (placement?.placementType === PlacementType.SINGLE) {
                    if (placement.vestaExternalId === externalId) {
                      foundInGroup = true;
                    }
                  }
                }
              }
            }
          }
          if (foundInGroup) {
            this.visualizzaSchermataDiConfigurazione();
            this.clickSuPlacement(group, true, 'GROUP_ID-' + group.idGroup);
//            this.configuration.aggiornaVesta();
          } else if (!foundInGroup && clickedPlacement) {
            this.visualizzaSchermataDiConfigurazione();
            this.clickSuPlacement(clickedPlacement, false, 'GROUP_ID-' + group.idGroup);
//            this.configuration.aggiornaVesta();
          }
        }
      }
    }
  }

  private handleVestaClickUngroupedTab(externalId: string): void {
    let clickedPlacement: ConfigurabilityCommercialLines | undefined;
    if (this.product?.configurability && this.product.configurability.ungrouped.length > 0) {
      for (const element of this.product.configurability.ungrouped) {
        if (element.ungroupedElements?.length > 0) {
          for (const placement of element.ungroupedElements) {
            if (!clickedPlacement) {
              if (placement.placementType === PlacementType.GROUP && placement.placementList.length > 0) {
                const found = placement.placementList.find((plc: ConfigurabilityCommercialLines) => {
                  return plc.vestaExternalId === externalId;
                });
                if (found) {
                  clickedPlacement = placement;
                }
              } else if (placement.placementType === PlacementType.SINGLE) {
                if (placement.vestaExternalId === externalId) {
                  clickedPlacement = placement;
                }
              }
            }
          }
        }
      }
      if (this.product.optionalConfigurability) {
        for (const optional of this.product.optionalConfigurability.unboxed) {
          if (!clickedPlacement) {
            if (optional.placementType === PlacementType.SINGLE) {
              if (optional.vestaExternalId === externalId) {
                clickedPlacement = optional;
              }
            }
          }
        }
      }
    }
    if (clickedPlacement) {
      this.visualizzaSchermataDiConfigurazione();
      this.clickSuPlacement(clickedPlacement, false, 'GROUP_ID-UNGROUPED');
//      this.configuration.aggiornaVesta();
    }
  }

  /*
    private refreshConfigurationId(): void {
      if (this.modelConfiguration) {
        if (this.configurationId) {
          this.modelConfiguration.configurationId = this.configurationId;
        } else {
          this.modelConfiguration.configurationId = null;
        }
      }
    }
  */

  private takeScreenshot(): Promise<void> {
    const actualProduct = this.product?.detail;
    if (!actualProduct?.no3D && this.common.vestaScreenshot && this.enableVesta) {
      return new Promise(resolve => {
        try {
          this.common.vestaScreenshot({camera: 'main', dimension: this.getWidthHeightVesta()}, (data: any) => {
            if (data?.base64) {
              this.screenshot.url = null;
              this.screenshot.base64 = data.base64;
              resolve();
            }
          });
      } catch (e) {
        this.screenshot.url = this.extractImage(actualProduct);
        resolve();
      }
      });
    } else {
      this.screenshot.url = this.extractImage(actualProduct);
      return Promise.resolve();
    }
  }

  private async saveConfigurationImage(configurationId: number): Promise<void> {
    if (this.screenshot.base64) {
      return this.orderService.saveConfigurationImageBase64(configurationId, this.screenshot.base64).toPromise().then(() => {
        this.screenshot.base64 = null;
        this.screenshot.url = [
          this.summaryData?.imagePath.replace(String(this.summaryData?.configurationId), String(configurationId)),
          '?dimension=hd&', Math.floor(Date.now() / 100) % 1000000].join('');
        this.cd.markForCheck();
      });
    } else if (this.screenshot.url) {
      return this.orderService.saveConfigurationImageUrl(configurationId, this.screenshot.url).toPromise();
    } else {
      return this.orderService.saveConfigurationImageUrl(configurationId, this.extractImage(this.product?.detail)).toPromise();
    }
  }

  private extractImage(actualProduct: any): string {
    let image;
    if (actualProduct?.imagePath) {
      image = actualProduct.imagePath;
      // } else if (actualProduct?.ext_links?.length) {
      //   image = actualProduct.ext_links[0];
    } else if (actualProduct?.images?.list?.length) {
      // image = actualProduct.images[0].imagePath ? actualProduct.images[0].imagePath : actualProduct.images[0];
      image = actualProduct.images.list[0];
    } else {
      image = '';
    }
    return this.repairUrl.transform(image);
  }

  private deselectAllConfigurations(): void {
    // if (this.configurationsComponent) {
    //   this.configurationsComponent.forEach((conf: ModelConfigurationsComponent) => conf.collapseAll());
    // }
    // this.listsAccordion?.closeAll();

    if (this.product?.configurazioniPrebuilt && this.product?.configurazioniPrebuilt?.length > 0) {
      for (const conf of this.product.configurazioniPrebuilt) {
        conf.selected = false;
        conf.editing = false;
      }
    }
    if (this.product?.configurazioniSalvate && this.product?.configurazioniSalvate?.length > 0) {
      for (const conf of this.product.configurazioniSalvate) {
        conf.selected = false;
        conf.editing = false;
      }
    }
  }

  private aggiornaTabSelezionato(groupLabel: string): void {
    if (groupLabel) {
      const separatedGroupLabel = groupLabel.split('-');
      if (this.modelConfiguration && separatedGroupLabel[1]) {
        this.modelConfiguration.tabSelezionato = separatedGroupLabel[1];
        this.vestaService.estraiStrutturaRaggruppata(this.estraiStrutturaTabSelezionato() || [], true);
      }
    }
  }

  private getDataForTrackService(): {productId: string, productName: string, productCategory: string} {
    if (this.product.detail) {
      return {
        productId: this.product.detail.productCode,
        productCategory: this.product.detail.categoryNameForTrack,
        productName: this.product.detail.productNameForTrack
      };
    }
    throw new Error('product detail not found');
  }

  private getProductInfo(params: { productId: number }, callModelBomId = false): void {
    this.modelService.modelItemDetail(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data?.error) {
          this.common.showErrorToast(data?.error);
        } else {
          this.product.detail = data?.product;
          if (this.product.detail?.images?.list) {
            this.product.detail.images.converted = this.product?.detail?.images?.list?.map((image, index) => ({
              src: this.repairUrl.transform(image),
              alt: `${this.product?.detail?.productName} - Image ${index++}`,
              title: `${this.product?.detail?.productName} - Image ${index++}`,
              loading: 'lazy'
            }));
          }
          if (this.product.detail && callModelBomId) {
            this.modelBomId(this.product.detail);
            this.trackEventsService.viewProductConfigurator(this.getDataForTrackService());
          }
          // TODO: delete this
          // this.product.images = [];
          // this.academy.getModelElementImage(data?.product).then((images: (string | {imagePath?: string})[]) => {
          //   console.log(images);
          //   this.product.images = images;
          // });
          if (!this.product.detail?.vestaExternalLink) {
            this.notFound = true;
          }
          this.cd.markForCheck();
        }
      });
  }

  private initalizeModelConfiguration(newPrebuilt?: boolean): void {
    this.modelConfiguration = {
//      categoryId: this.product.detail?.categoryId, never used
      productId: Number(this.productId),
      tabSelezionato: ConfigurationTab.UNGROUPED,
//      configurationId: null,
//      canValidate: null, never used
      editing: false,
      newPrebuilt: newPrebuilt ? newPrebuilt : false
    };
    // this.configuration.strutturaConfigurata = undefined;
    // this.configuration.strutturaOriginale = undefined;
    // this.configuration.strutturaOriginaleSuddivisaPerTab = undefined;
    // this.configuration.strutturaOpzionaleOriginale = undefined;
    this.currentTabIndex = 0;
  }

  private filterEtoConfigurations(data: any): any {
    if (data?.error) {
      return data;
    } else if (data?.configurations) {
      return {
        ...data,
        configurations: data?.configurations.filter((configuration: ModelPrebuiltConfiguration) =>
          this.canRequestEto || !configurationHasEto(configuration)
        )};
    } else {
      return data;
    }
  }

  private estraiConfigurazioniPrebuilt(params: { productId: number }): Observable<any> {
    return this.modelService.modelItemPrebuiltConfigurations(params).pipe(
      map((data: any) => this.filterEtoConfigurations(data)),
      tap((data: any) => {
      if (data?.error) {
        this.common.showErrorToast(data?.error);
        this.checkIfAutoEnableVesta();
      } else {
        this.product.configurazioniPrebuilt = data?.configurations;
        if (!this.configuration.ottieniStrutturaApplicata && !this.singleConfigurationId && !this.orderService.copyConfigurationId) {
          this.applyDefaultPrebuilt();
        }
        this.cd.markForCheck();
      }
    }));
  }

  private estraiConfigurazioniSalvate(params: { productId: number, singleConfigurationId?: number, myConfigurations?: boolean, customerId?: number, orderId?: number, copyConfigurationId?: number }): void {
    this.modelService.modelItemSavedConfigurations(params).pipe(
      map((data: any) => this.filterEtoConfigurations(data)),
      takeUntil(this.destroy$)
    ).subscribe((data) => {
      if (data?.error) {
        this.common.showErrorToast(data?.error);
      } else {
        if (params.singleConfigurationId && data?.configurations?.length === 1) {
          this.applyConfiguration(data?.configurations[0]);
          this.checkIfAutoEnableVesta();
          this.editCurrentConfiguration(true);
        } else if (params.myConfigurations) {
          this.product.configurazioniSalvate = data?.configurations;
        } else if (params.customerId) {
          this.product.configurazioniCliente = data?.configurations;
        } else if (params.orderId) {
          this.product.configurazioniOrdine = data?.configurations;
        } else if (params.copyConfigurationId) {
          if (data?.configurations?.length === 1) {
            this.applyConfiguration(data?.configurations[0]);
            this.checkIfAutoEnableVesta();
            this.editCurrentConfiguration(true);
          } else {
            this.applyDefaultPrebuilt();
          }
        }
        this.cd.markForCheck();
      }
    });
  }

  private searchPlacementInGroup(placementId: number, group: ConfigurabilityCommercialLines | ConfigurabilityGroup): Placement | null {
    if (group.placementType === PlacementType.GROUP) {
      const placementList: ConfigurabilityCommercialLines[] = 'groupedElements' in group ? group.groupedElements : group.placementList;
      for (const plc of placementList) {
        const placement = this.searchPlacementInGroup(placementId, plc);
        if (placement !== null) {
          return placement;
        }
      }
    } else if (group.placementId === placementId) {
      return group;
    }
    return null;
  }

  private setRuleInfo(): void {
    if (this.workingPlacement && this.selectedWidgetConfiguration) {
      const allPlacements = this.getAllPlacementsForCurrentTab();
      this.currentRule = {
        mastersConfiguration: CrossRestrictionUtils.sortRuleInfoWithMasterConf(
          CrossRestrictionUtils.getMastersForPlacementConfLineId(this.workingPlacement, this.selectedWidgetConfiguration.placementConfLineId, this.configuration.getAllElementsForSummary),
          this.lastConfiguredPlacements
        ),
        placementsWithSameConfiguration: CrossRestrictionUtils.getPlacementsWithForceSameConfiguration({
          configuration: this.selectedWidgetConfiguration,
          selectedMaterialColor: this.configuration.createMockMaterialColor()
        } as PlacementConfigurationSummary, allPlacements)
          .map(plc => allPlacements.find(conf => CrossRestrictionUtils.isMatchPlacement(plc, conf)))
          .filter(conf => conf) as ConfigurabilityCommercialLines[]
      };
    } else {
      this.currentRule = undefined;
    }
  }

  private checkDisabledWith(placement: ConfigurabilityCommercialLines | ConfigurabilityGroup | PlacementOptional): string {
    const optional = this.configuration.strutturaModelloConfigurata.find((element: VirginStructureConfigurata) =>
      element.active && (
        ('placementId' in placement && element.optionalElementInfo?.placementToDeactivateList?.includes(placement.placementId || -1)) ||
        (element.optionalElementInfo?.groupToDeactivateList?.includes(placement.idGroup || -1))
      ));
    if (optional) {
      const boxedId = optional.optionalElementInfo?.boxedId;
      const box = this.configuration.strutturaOpzionaleOriginale?.[BoxedType.BOXED].find((boxed) => boxed.boxId === boxedId);
      return box ? box.boxName : optional.placementName;
    } else {
      return '';
    }
  }

  public isConfigurableElement(placement: ConfigurabilityCommercialLines): boolean {
    return isSinglePlacement(placement) ? placement.configurableElement : true;
  }

  public isConfigurableOrMutuallyExclusive(placement: ConfigurabilityCommercialLines): boolean {
    if (isSinglePlacement(placement)) {
      return placement.configurableElement || placement.hasMutuallyExclusiveOption;
    } else {
      return true;
    }
  }

  public saveEditing(): void {
    if (this.canShowSaveEditing()) {
      this.loaded = false;
      this.getSummary(this.singleConfigurationId, true)
        .then((summary: any) => this.takeScreenshot().then(() => this.saveConfigurationImage(summary.configurationId)))
        .then(() => {
          this.loaded = true;
          this.editingSaved = true;
          if (this.orderService.currentOrder?.id === this.currentOrderId) {
            this.openProformaDetail();
          } else if (this.currentOrderId === -1 && this.singleConfigurationId) {
            this.lastModifiedConfigurationId = this.singleConfigurationId;
            this.updateAfterSavingConf(this.singleConfigurationId);
          }
          this.cd.markForCheck();
      });
    }
  }

  private openProformaDetail(): void {
    const dialogRef = this.modalService.openOrderModal<{
      customer: any,
      showSelectedOrder?: { id: number },
      isToRevertConfiguration: boolean,
      lastConfigurationId?: number
    }>({
      client: this.orderService?.currentClient
    });
    dialogRef.componentInstance.lastConfigurationId = this.singleConfigurationId ? Number(this.singleConfigurationId) : undefined;
  }

  public canShowSaveEditing(): boolean {
    return this.showSaveEditing && !!this.singleConfigurationId && (this.currentOrderId === -1 || this.orderService.currentOrder?.id === this.currentOrderId);
  }

  public labelAddToProforma(): string {
    if (!this.canShowSaveEditing()) {
      return !this.etoFlow && !this.hasAtLeastOneEtoLine() ? this.proformaLabels.addTo : 'AGGIORNA_PROFORMA_ETO';
    } else {
      return !this.etoFlow && !this.hasAtLeastOneEtoLine() ? this.proformaLabels.addNewTo : 'AGGIUNGI_NUOVO_PROFORMA_ETO';
    }
  }

  public removeImageFromList(imageUrl: string): void {
    const i = this.product?.detail?.images?.list?.indexOf(imageUrl);
    if (this.product?.detail?.images?.list && i !== -1 && i !== undefined) {
      this.product.detail.images.list.splice(i, 1);
    }
  }

  public materialNumberFormat(materialNumberString: string | undefined): string {
    if (materialNumberString) {
      const materialNumber = Number(materialNumberString.replace(/\./g, ''));
      return materialNumber <= 100000 ? new Intl.NumberFormat('it-IT').format(materialNumber) : 'OLTRE_100MILA';
    } else {
      return '';
    }
  }

  public toggleRightCol(): void {
    this.isDrawerConfigurationClosed = !this.isDrawerConfigurationClosed;
  }

  public getConfigurationPrice(): string {
    if (this.summaryData) {
      if (this.summaryData.eto) {
        return 'PREZZO_NON_CALCOLABILE';
      } else {
        return this.isDefaultUntaxedPrice ? this.summaryData.totalPrice : this.summaryData.totalPriceTaxed;
      }
    } else {
      return '';
    }
  }

  private askToRestoreModal(emptyOrTimeout: boolean | symbol): Observable<HistoryMessage> {
    if (emptyOrTimeout === this.warningTimeoutObj.TIMEOUT || this.singleConfigurationId) {
      this.configuration.historyAction.next({message: HistoryMessage.TimeoutSoApplyWaitingStructure});
      return of(HistoryMessage.TimeoutSoApplyWaitingStructure);
    } else if (emptyOrTimeout === true) {
      this.configuration.historyAction.next({message: HistoryMessage.EmptySoApplyWaitingStructure});
      return of(HistoryMessage.EmptySoApplyWaitingStructure);
    } else {
      return this.afterViewChecked$.pipe(
        first(),
        switchMap(() => this.askToRestore ? this.dialog.open(this.askToRestore, {disableClose: true}).afterClosed() : of(null)),
        map((recover) => recover ? HistoryMessage.StartRecovering : HistoryMessage.ResetAndApplyWaitingStructure),
        tap((message) => {
          this.configuration.historyAction.next({message});
        })
      );
    }
  }

  private getWidthHeightVesta(): {width: number, height: number} {
    if (this.vestaContainer) {
      const vestaStyle = getComputedStyle(this.vestaContainer.nativeElement);
      const width = +vestaStyle.width.replace('px', '') || 1280;
      const height = +vestaStyle.height.replace('px', '') || 1280;
      const minimum = Math.min(width, height);
      return {width: width / minimum * 1280, height: height / minimum * 1280};
    }
    return {width: 1280, height: 1280};
  }

  login(): void {
    this.authService.goToLoginPage();
  }

  showSummaryRecap(): boolean {
    return this.authService.currentUserPermission.canSeeSummaryRecap;
  }

  public printSummaryRecapPdf(): void {
    this.isPrinting = true;
    const summaryData = this.summaryData;
    this.takeScreenshot().then(() => {
      if (summaryData) {
        this.saveConfigurationImage(summaryData.configurationId).then(() => {
          this.modelService.summaryPdfPrint(summaryData.configurationId)
            .pipe(
              map((res: any) => {
                if (res?.error) {
                  this.common.showErrorToast(res.error);
                }
                else if (!res?.error && res?.base64) {
                  this.downloadPdf(res?.base64, res.fileName);
                }
            }))
            .subscribe(() => {
              this.isPrinting = false;
              this.cd.markForCheck();
            });
        });
      }
    });
  }

  public getConfigurationName(): string | undefined {
    const selectedConfiguration = this.modelConfiguration?.selectedConfigurationData;
    return selectedConfiguration?.configurationSaleCode || selectedConfiguration?.configurationName;
  }
}
